import React, { useReducer, useEffect } from 'react';
import Close from '../../../../assets/svg/close.svg';
import CustomRadio from '../../../../components/common/customRadio/CustomRadio';
import styles from './reportSetup.css';
import { useSelector, useDispatch } from 'react-redux';
import { updateSettingsQuestionAnswers, getSettings } from '../../../../data/quiz/settings/actions';
import { withRouter } from 'react-router';
import DataRange from '../../../../components/dataRange/DataRange';


let initialState = {
    showDataRange: false,
    mode: 'none',
    enabled: false,
    enter_email: '',
    isEmail: true
};

const reducer = ( state, action ) => {
    switch ( action.type ) {
        case 'CHANGE-ALL-DATA':
        case 'ADD-ALL-DATA': {
            return { ...state, ...action.data };
        }
    }
};

const initializer = state => state;

/**
 *
 * @param closeForm
 * @param match
 * @returns {JSX.Element}
 * @constructor
 */
const ReportSetup = ( { closeForm, match, publishSetup } ) => {
    const { profile, localization: { content }, settings } = useSelector( state => state );
    const [ data, dispatch ] = useReducer( reducer, initialState, initializer );
    const { mode, enabled, enter_email, isEmail, showDataRange } = data;
    const actionDispatch = new useDispatch();
    const { params: { quizID } } = match;

    useEffect( () => {
        actionDispatch( getSettings( quizID ) );
    }, [] );

    useEffect( () => {
        if ( settings?.general ) {
            const { general: { email_report, another_email } } = settings;

            let email = another_email;

            if ( publishSetup && another_email === null ) {
                email = profile.email;
                actionDispatch( updateSettingsQuestionAnswers( quizID, {
                    another_email: email,
                    email_report: 'weekly'
                } ) );

            }
            const isEnable = email !== null;

            dispatch( {
                type: 'CHANGE-ALL-DATA',
                data: { mode: email_report, enter_email: email, enabled: isEnable }
            } );
        }
    }, [ settings ] );

    const handleSetReportMode = ( e, { value } ) => {
        actionDispatch( updateSettingsQuestionAnswers( quizID, {
            email_report: value
        } ) );
        dispatch( { type: 'CHANGE-ALL-DATA', data: { mode: value } } );
    };
    /**
     *
     * @param e
     */
    const handleChangeEmail = ( e ) => {
        const value = e.target.value;
        const isEnable = value !== '';
        const theMode = value === '' ? 'none' : mode;
        const regex = new RegExp( '[a-z0-9]+@[a-z]+\.[a-z]{2,3}' );
        const isEmail = regex.test( value );
        dispatch( {
            type: 'CHANGE-ALL-DATA',
            data: { isEmail: isEmail, enter_email: value, mode: theMode, enabled: isEnable }
        } );
    };

    const handleSaveEmail = () => {
        const enterEmail = enter_email === '' ? null : enter_email;
        const emailSettings = enter_email === '' ? { email_report: 'none' } : {};
        actionDispatch( updateSettingsQuestionAnswers( quizID, {
            ...emailSettings,
            another_email: enterEmail
        } ) );

    };

    const handleFormClose = () => {
        closeForm();
    };

    const handleDataRange = ( data ) => {
        actionDispatch( updateSettingsQuestionAnswers( quizID, { ...data } ));
        handleCloseRange();
    };

    const handleCloseRange = () => {
        dispatch( {
            type: 'CHANGE-ALL-DATA', data: {
                showDataRange: false
            }
        } );
    };

    const handleOpenDataRange = () => {
        dispatch( {
            type: 'CHANGE-ALL-DATA', data: {
                showDataRange: true
            }
        } );
    };

    return (
        <div className={ styles.wrapper }>
            <nav><Close onClick={ handleFormClose }/></nav>
            <h3>{ content.quiz.statistics.email_report_form_title }</h3>
            <ul>
                <li className={ styles.inputBlock }>
                    <input
                        className={ `${ styles.emailStyle } ${ isEmail ? styles.theEmailStyle : styles.notEmailStyle } ` }
                        value={ enter_email }
                        onBlur={ handleSaveEmail }
                        onChange={ handleChangeEmail }
                        type={ 'text' }
                        placeholder={ `${ content.quiz.statistics.enter_email }...` }/>
                </li>
                <li className={ enabled ? styles.inputBlock : styles.inputBlockDes }>

                    { !publishSetup ? <CustomRadio
                            className={ styles.input2 }
                            value='weekly'
                            disabled={ !enabled }
                            label={ content.quiz.statistics.report_weekly }
                            checked={ mode === 'weekly' }
                            onChange={ handleSetReportMode }
                        /> :
                        <a onClick={ handleOpenDataRange }> Set date range </a>
                    }
                </li>
                <li className={ enabled ? styles.inputBlock : styles.inputBlockDes }>
                    <CustomRadio
                        className={ styles.input2 }
                        value='daily'
                        disabled={ !enabled }
                        label={ content.quiz.statistics.report_daily }
                        checked={ mode === 'daily' }
                        onChange={ handleSetReportMode }
                    />
                </li>
                <li className={ enabled ? styles.inputBlock : styles.inputBlockDes }>
                    <CustomRadio
                        className={ styles.input2 }
                        value='newLead'
                        disabled={ !enabled }
                        label={ content.quiz.statistics.report_new_registration }
                        checked={ mode === 'newLead' }
                        onChange={ handleSetReportMode }
                    />
                </li>
                <li className={ enabled ? styles.inputBlock : styles.inputBlockDes }>
                    <CustomRadio
                        className={ styles.input2 }
                        value='none'
                        disabled={ !enabled }
                        label={ content.quiz.statistics.report_none }
                        checked={ mode === 'none' }
                        onChange={ handleSetReportMode }
                    />
                </li>

            </ul>
            {
                showDataRange && <DataRange
                    onDataRange={ handleDataRange }
                    closeHandle={ handleCloseRange }
                />
            }

        </div>
    );
};

export default withRouter( ReportSetup );